<template>
  <div>
    <!-- 轮播图 -->
    <el-carousel
      class="banner"
      style="margin-top: 66.1px; height: 381px"
      indicator-position="outside"
    >
      <el-carousel-item
        style="height: 381px"
        v-for="(item, index) in pic"
        :key="index"
      >
        <img :src="item.url" alt="" />
      </el-carousel-item>
    </el-carousel>

    <!-- 版心 -->
    <div class="container">
      <div style="width: 88%; margin: 0 auto">
        <div class="right_letter" style="margin-top: 52px">core products</div>
        <h2 class="left_name">核心产品</h2>

        <div class="hidden">
          <el-carousel
            class="product_height"
            :interval="4000"
            type="card"
            height="400px"
            style="
              background-color: #63626237;
              border-radius: 10px;
              box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
              transition: box-shadow 0.3s ease;
            "
          >
            <el-carousel-item
              v-for="item in Items"
              :key="item.id"
              style="
                background-color: #fff;
                border-radius: 10px;
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                display: flex;
                flex-direction: column;
                justify-content: space-around;
              "
            >
              <router-link
                class="product_center_b"
                :to="'/ProductDetail/' + item.id"
                style="text-decoration: none"
              >
                <img :src="item.url" alt="" class="product-image"
              /></router-link>
              <div class="description">
                {{ item.productName }} {{ item.productModel }}
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>

        <div class="block">
          <el-carousel height="360px" class="product_center_block">
            <el-carousel-item
              v-for="item in Items"
              :key="item.id"
              style="
                background-color: #fff;
                border-radius: 10px;
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
                display: flex;
                flex-direction: column;
                justify-content: space-around;
              "
            >
              <router-link
                class="product_center_b"
                :to="'/ProductDetail/' + item.id"
                style="text-decoration: none"
              >
                <img :src="item.url" alt="" class="product-image" />
              </router-link>

              <div class="description">
                {{ item.productName }} {{ item.productModel }}
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>

      <div style="width: 88%; margin: 0 auto">
        <div>
          <div class="right_letter">main products</div>
          <h2 class="left_name">主推产品</h2>
          <div class="or_img">
            <img
              src="../assets/image/空气环境实时监测系统.png"
              alt="空气环境实时监测系统"
            />
          </div>
        </div>
      </div>
      <div style="width: 88%; margin: 0 auto">
        <div class="right_letter">news Information</div>
        <h2 class="left_name">新闻动态</h2>
        <el-row :gutter="40" style="display: flex; flex-direction: column">
          <el-col :span="24"
            ><div class="grid-content">
              <router-link to="/NewsCenter">
                <div class="all">
                  <div class="all_company">
                    <div class="first">公司新闻</div>
                    <div class="letter">COMPANY NEWS</div>
                  </div>
                  <div class="all_bottom">
                    <div class="all_img">
                      <img src="../assets/image/公司新闻.png" alt="公司新闻" />
                    </div>
                    <div class="all_bottom_left_all">
                      <div
                        class="all_bottom_left"
                        v-for="item in dataItems"
                        :key="item.id"
                      >
                        <div class="all_title">
                          <router-link :to="'/NewsDetail/' + item.id">
                            <div class="black">
                              {{ item.title }}
                            </div></router-link
                          >
                        </div>
                        <div class="time">
                          <div>{{ item.datetime }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div></router-link
              >
            </div></el-col
          >
          <el-col :span="24"
            ><div class="grid-content bg-purple-light">
              <router-link to="/NewsCenter">
                <div class="all">
                  <div class="all_company">
                    <div class="first">行业资讯</div>
                    <div class="letter">INDUSTRY NEWS</div>
                  </div>
                  <div class="all_bottom">
                    <div class="all_img">
                      <img src="../assets/image/行业资讯.png" alt="行业资讯" />
                    </div>
                    <div class="all_bottom_left_all">
                      <div
                        class="all_bottom_left"
                        v-for="item in IduItems"
                        :key="item.id"
                      >
                        <div class="all_title">
                          <router-link :to="'/NewsDetail/' + item.id">
                            <div class="black">
                              {{ item.title }}
                            </div></router-link
                          >
                        </div>
                        <div class="time">
                          <div>{{ item.datetime }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div></router-link
              >
            </div></el-col
          >
        </el-row>
      </div>
      <div style="width: 88%; margin: 0 auto">
        <div class="right_letter">application area</div>
        <h2 class="left_name">应用领域</h2>
        <div class="application_area">
          <div class="grid-content">
            <img src="../assets/image/光纤.png" alt="光纤" />
          </div>
          <div class="grid-content">
            <img src="../assets/image/木器.png" alt="木器" />
          </div>
          <div class="grid-content">
            <img src="../assets/image/电子.png" alt="电子" />
          </div>
          <div class="grid-content">
            <img src="../assets/image/UV系统.png" alt="UV系统" />
          </div>
          <div class="grid-content">
            <img src="../assets/image/涂布.png" alt="涂布" />
          </div>
          <div class="grid-content">
            <img src="../assets/image/食品制造.png" alt="食品制造" />
          </div>
          <div class="grid-content">
            <img src="../assets/image/科研院校.png" alt="科研院校" />
          </div>
          <div class="grid-content">
            <img src="../assets/image/生物制药.png" alt="生物制药" />
          </div>
        </div>
        <!-- <el-row :gutter="20" style="margin-top: 50px">
          <el-col :span="6"
            ><div class="grid-content">
              <img src="../assets/image/光纤.png" alt="光纤" /></div
          ></el-col>
          <el-col :span="6"
            ><div class="grid-content">
              <img src="../assets/image/木器.png" alt="木器" /></div
          ></el-col>
          <el-col :span="6"
            ><div class="grid-content">
              <img src="../assets/image/电子.png" alt="电子" /></div
          ></el-col>
          <el-col :span="6"
            ><div class="grid-content">
              <img src="../assets/image/UV系统.png" alt="UV系统" /></div
          ></el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top: 50px">
          <el-col :span="6"
            ><div class="grid-content">
              <img src="../assets/image/涂布.png" alt="涂布" /></div
          ></el-col>
          <el-col :span="6"
            ><div class="grid-content">
              <img src="../assets/image/食品制造.png" alt="食品制造" /></div
          ></el-col>
          <el-col :span="6"
            ><div class="grid-content">
              <img src="../assets/image/科研院校.png" alt="科研院校" /></div
          ></el-col>
          <el-col :span="6"
            ><div class="grid-content">
              <img src="../assets/image/生物制药.png" alt="生物制药" /></div
          ></el-col>
        </el-row> -->
      </div>

      <div style="width: 88%; margin: 0 auto; margin-bottom: 30px">
        <div class="right_letter">Integrated cleanroom service content</div>
        <h2 class="left_name">洁净室一体化服务内容</h2>
        <el-row type="flex" class="row-bg" style="margin-bottom: -18px">
          <el-col :span="24"
            ><div class="grid-content card">
              <strong>净化类智能设备</strong>
              <p>
                传递窗、FFU、称量罩/传递窗、FFU、称量罩/间、工作台、生物安全柜、层流车、层流罩、隔离罩、风淋室、高效过滤器、局部净化单元FFU等定制设备、设备改造、调试、小型配套设备。
              </p>
            </div></el-col
          >

          <el-col :span="24"
            ><div class="grid-content card">
              <strong>检测类仪器仪表</strong>
              <p>
                粒子计数器(单体/在线)、浮游菌、烟雾发生器、高效过滤器计数检漏仪、风量仪、洁净环境测试组件、压缩空气质量检测仪、颗粒稀释器、气溶胶发生器、压缩空气减压器、智能粒子采样机器人。
              </p>
            </div></el-col
          >

          <el-col :span="24"
            ><div class="grid-content card">
              <strong
                >空气实时监测系统、洁净室智能巡检系统、洁净室光强能量在线监测系统</strong
              >
              <p>
                针对洁净室环境参数的软硬件一体解决方案;实现智能仪器、仪表物联网+数据服务+AIGC方向(大模型训练中)
                (监测粒子、浮游菌、温湿度、压差、风速、光照及AMC、VOC气体及其他可接入外部参数设备等);
                是洁净室智慧管控平台重要组织部分。
              </p>
            </div></el-col
          >
        </el-row>
        <el-row type="flex" class="row-bg" justify="space-between">
          <el-col :span="24"
            ><div class="grid-content card">
              <strong>洁净室智慧管控平台</strong>
              <p>
                1、洁净室内智能化水平:推动洁净室内提高效能的各类型智能仪器、仪表、设备等智能化发展与使用;
                2、洁净室平台化管控:把依托洁净室场景下的各类型信息独立监管控系统(如:门禁、照明、设备运行、空气环境(包含AMC)、新风、耗能、能量等)
                及各类型智能仪器、仪表、设备等物联组网、搭建统一平台管理，并关联数据搜集、分类、分析等用于:(1)指导生产曾理行为并带来效能提升;(2)使用数据大模型及AIGC来应对异常的改善措施实施。
              </p>
            </div></el-col
          >
          <el-col :span="24"
            ><div class="grid-content card">
              <strong>计量、校准、检测、验证</strong>
              <p>
                央企华东中检(CCIC)战略合作单位;为用户提供计量、校准、检测、验证等高性价比第三方服务。
              </p>
            </div></el-col
          >

          <el-col :span="24"
            ><div class="grid-content card">
              <strong>信息运维/其他服务</strong>
              <p>
                为用户提供驻点软、硬件、数据运维、运维委外、智能产线、智能工厂、解决方案及措施、洁净室验证等服务内容。
              </p>
            </div></el-col
          >
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { getDicList, getProductList, getNewsList } from "@/api";
export default {
  data() {
    return {
      activeNames: ["1"],
      pic: [
        { url: require("../assets/image/智慧存享.jpg") },
        { url: require("../assets/image/智慧洁净室服务商.jpg") },
        { url: require("../assets/image/价值观.png") },
      ],
      Items: [],
      dataItems: [],
      IduItems: [],
      queryForm: {
        query: "",
        query2: "1",
        pageNum: 1,
        pageSize: 12,
      },
      newsqueryForm: {
        query: "",
        query2: "1",
        pageNum: 1,
        pageSize: 6,
      },
      indnewsqueryForm: {
        query: "",
        query2: "2",
        pageNum: 1,
        pageSize: 6,
      },
      // items: [
      // {
      //   imageUrl: require("../assets/image/浮游菌采样器.png"),
      //   description: "浮游菌采样器JC-6FT",
      // },
      // {
      //   imageUrl: require("../assets/image/大（小）流量尘埃粒子计数器.jpg"),
      //   description:
      //     "大/小流量尘埃粒子计数器JC-601T/JC-610T/JC-650T/JC-6100T",
      // },
      // {
      //   imageUrl: require("../assets/image/手持式尘埃粒子计数器.png"),
      //   description: "手持式尘埃粒子计数器JC-601H",
      // },
      // 其他仪器的名称和描述信息依此类推
      // ],
      activeName: "first",
    };
  },
  created() {
    this.initProduct(); // 组件创建时调用初始化函数
    this.cotegoryOptions();
    this.initloadProduct();
  },
  methods: {
    handleChange(val) {
      console.log(val);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    initProduct() {
      getProductList(this.queryForm)
        .then((res) => {
          if (res.code === "200") {
            this.Items = res.data.records;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    initloadProduct() {
      const Form = {
        query: "",
        query2: "",
      };
      getProductList(Form)
        .then((res) => {
          if (res.code === "200") {
            this.dataitem = res.data.records;
            // 获取前三条数据
            this.instruments = this.dataitem.slice(0, 3);
          }
        })
        .catch((err) => {
          console.log(err);
        });
      getNewsList(this.newsqueryForm)
        .then((res) => {
          if (res.code === "200") {
            this.dataItems = res.data.records;
          }
        })
        .catch((err) => {
          console.log(err);
        });
      getNewsList(this.indnewsqueryForm)
        .then((res) => {
          if (res.code === "200") {
            this.IduItems = res.data.records;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    cotegoryOptions() {
      getDicList("productcategory")
        .then((res) => {
          if (res.code === "200") {
            console.log(res);
            this.options = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@media (max-width: 455px) {
  .block .description {
    margin-top: 50px !important;
  }
}
@media (max-width: 700px) {
  .hidden {
    display: none;
  }
  .right_letter {
    margin-top: 58px !important;
  }
  .banner {
    display: none;
  }
}
@media (max-width: 960px) {
  .hidden {
    display: none;
  }
  .right_letter {
    margin-top: 58px !important;
  }
  .banner {
    display: none;
  }
}
@media (max-width: 455px) {
  .product_center_b {
    margin-bottom: -138px;
  }
}
@media (min-width: 966px) {
  .block {
    display: none;
  }
}
.application_area {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between; /* 或使用 space-around, space-evenly 等 */
}

.grid-content {
  flex: 0 0 calc(50% - 10px); /* 默认情况下，每行显示两个，减去一些间距 */
  margin-bottom: 20px; /* 为每个元素添加一些底部间距 */
}

/* 当屏幕宽度大于某个值时，每行显示四个 */
@media (min-width: 768px) {
  .grid-content {
    flex: 0 0 calc(25% - 10px); /* 当屏幕变宽时，每行显示四个 */
  }
}

/* 如果需要更小的屏幕尺寸下一行显示两个，可以添加更多的媒体查询 */
@media (max-width: 767px) {
  .grid-content {
    flex: 0 0 calc(50% - 10px); /* 当屏幕变窄时，每行显示两个 */
  }
}
@media (max-width: 500px) {
  /* .banner {
    display: none;
     flex-direction: column !important; 
  }*/
  .all_img,
  .time,
  .banner {
    display: none;
  }
  .black {
    font-size: 14px !important;
    white-space: nowrap; /* 防止文本换行 */
    overflow: hidden; /* 隐藏超出容器的文本 */
    text-overflow: ellipsis; /* 在文本溢出时显示省略号 */
  }
  .first {
    font-size: 22px;
  }
}
.card {
  height: 95%;
  // line-height: 40px;
  /* 增加边框宽度和颜色对比度 */
  border: 2px solid #ccc; /* 使用蓝色边框增加对比度 */

  /* 保持圆角 */
  border-radius: 10px;

  /* 添加阴影以增强立体感 */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

  /* 设置内边距 */
  padding: 20px;

  /* 背景色保持白色 */
  background-color: #fff;

  /* 添加边距 */
  margin-bottom: 20px;

  /* 添加过渡效果，使卡片在鼠标悬停时有所变化 */
  transition: box-shadow 0.3s ease;
}

/* 鼠标悬停时的效果 */
.card:hover {
  box-shadow: 0 8px 26px rgba(0, 0, 0, 0.2);
  cursor: pointer;
}

/* 为卡片内的标题和段落添加样式 */
.card strong {
  display: block;
  margin-bottom: 10px;
  color: #333; /* 与边框颜色相协调 */
}

.card p {
  margin: 0;
  color: #6c757d; /* 使用较暗的灰色文字 */
}
.section {
  position: relative; /* 确保伪元素可以相对于这个元素定位 */
  display: inline-block; /* 确保元素的宽度与其内容相匹配 */
  color: #333; /* 文本颜色 */
  padding-bottom: 3px; /* 为下面的线留出空间 */
  margin-bottom: 20px;
  margin-top: 20px;
}
.section::after {
  content: ""; /* 伪元素的内容为空 */
  position: absolute; /* 绝对定位 */
  left: 0; /* 从左侧开始 */
  bottom: 0; /* 在元素底部 */
  height: 2px; /* 线的高度 */
  width: 100%; /* 线的宽度与元素宽度相同 */
  background-color: blue; /* 线的颜色 */
}
.or_img img {
  width: 100%;
}
.or_img {
  width: 97%;
  border-radius: 10px; /* 圆角 */
  box-shadow: 0 8px 10px rgba(0, 0, 0, 0.1); /* 添加阴影，创建立体感 */
  background-color: #fff; /* 背景色 */
  transition: box-shadow 0.5s ease; /* 添加阴影过渡效果 */
  margin-bottom: 40px;
  margin: 0 auto;
}
.description {
  margin-bottom: 5px;
}
.all_bottom_left_all {
  display: flex;
  flex-direction: column;
  width: 81%;
  height: auto;
}
.black {
  display: flex;
  flex-direction: column;
  // width: 200px;
  color: #333;
  font-size: 1vw;
  margin-left: 18px;
  text-align: left;
  display: block;
  white-space: nowrap; /* 防止文本换行 */
  // overflow: hidden; /* 隐藏超出容器的文本 */
  // text-overflow: ellipsis; /* 使用省略号表示被截断的文本 */
}
.all_title div:hover {
  color: rgb(6, 202, 35);
  cursor: pointer;
}
.time {
  // display: flex;
  // flex-direction: column;
  line-height: 30px;
  font-size: 0.7vw;
  // display: none;
  // text-align: right;
}
.all_title {
  overflow: hidden; /* 隐藏超出容器的文本 */
  line-height: 30px;
}
.letter {
  letter-spacing: 2px;
  font-size: 1vw;
  color: rgba(169, 179, 197, 0.5);
  font-style: italic;
}
.all_company {
  font-size: 2vw;
  font-weight: 600;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 20px;
}
.all_img {
  margin-top: -2px;
  width: 18%;
}
.all_img img {
  width: 100%;
  height: auto;
}
.all_bottom_left {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.all_bottom {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.all {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  background-color: white; /* 设置背景色为白色 */
  border-radius: 10px; /* 添加圆角 */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* 添加阴影效果 */
  transition: box-shadow 0.3s ease; /* 添加阴影过渡效果，使阴影变化更加平滑 */
  padding: 20px; /* 添加内边距，使内容与边框之间有一定的空间 */
  height: auto;
  color: #333;
}
.all:hover {
  cursor: pointer;
}

/* 当你想要卡片被悬停时显示更明显的立体效果，你可以添加一个悬停效果 */
.all:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2); /* 悬停时增加阴影的模糊度和强度 */
}
.describtion {
  height: 230px;
  margin: 0 auto;
  /* 使用 flex 实现垂直居中 */
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平左对齐 */
  text-align: left; /* 文本左对齐 */
  /* 首字空两格，假设一个中文字符宽度为 16px，则空两格为 32px */
  text-indent: 32px;
  /* 重置 line-height 以避免影响文本垂直居中 */
}
.news_top_2 {
  margin-top: -40px;
}
.news_top_1 {
  margin-top: 25px;
}
.news_bottom {
  text-align: right;
  margin-top: 10px;
  color: #333;
}
.news_bottom:hover {
  cursor: pointer;
  color: #f00;
}
.news_top {
  border: 1px solid #333;
}
.bg-purple {
  background: #d3dce6;
}
.grid-content {
  border-radius: 50px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
  display: flex;
  flex-direction: column;
}
.product-image {
  width: 55%; /* 或者你需要的具体宽度 */
  height: auto;
  margin-bottom: 7px; /* 或者你需要的具体边距 */
  margin-top: 3px;
}
.container {
  margin-top: 35px;
}
.right_letter {
  border-bottom: 2px solid #ccccccf0;
  text-align: right;
  margin-top: 80px;
}
.left_name {
  text-align: left;
  margin-top: 10px;
  margin-bottom: 30px;
}
i {
  margin-left: 3px;
}
dd {
  margin: 18px;
  padding: 0;
  border: 0;
  outline: none;
  box-sizing: border-box;
  display: block;
  margin-inline-start: 40px;
}

a {
  margin: 0;
  padding: 0;
  border: 0;
  color: #fff;
  font-size: inherit;
  vertical-align: baseline;
  outline: none;
  box-sizing: border-box;
  text-decoration: none;
}
dt {
  margin: 0;
  padding: 11;
  border: 0;
  outline: none;
  box-sizing: border-box;
  display: block;
}
nav {
  display: block;
}
* {
  margin: 0;
  padding: 0;
}
ul {
  list-style: none;
}
img {
  width: 100%;
}
#app {
  width: 100vm;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
